import { Node, NodeProps, NodeTypes } from '@xyflow/react';
import { ComponentType } from 'react';

import { ContactFlowActionType, ContactFlowParameter, Selector } from '~pages/SipConfiguration/domain';

import AnswerNode from './AnswerNode';
import CheckExclusionNode from './CheckExclusionNode';
import DefaultNode from './DefaultNode';
import DelayNode from './DelayNode';
import EnqueueNode from './EnqueueNode';
import EntryNode from './EntryNode';
import FetchLeadNode from './FetchLeadNode';
import HangUpNode from './HangUpNode';
import LexBotAudioNode from './LexBotAudioNode';
import NoOpNode from './NoOpNode';
import PlayMessageNode from './PlayMessageNode';
import SetAttributeNode from './SetAttributeNode';
import SetDispositionNode from './SetDispositionNode';
import TransferExternalNode from './TransferExternalNode';
import UnsetAttributeNode from './UnsetAttributeNode';
import WaitDTMFNode from './WaitDTMFNode';

export type ContactFlowNodeData = {
  type: string;
  parameter: ContactFlowParameter;
  sourceHandles?: { handleId: string; selector?: Selector }[];
  description?: string;
  isNew?: boolean;
};
export type ContactFlowNode = Node<ContactFlowNodeData>;
export type ContactFlowNodeProps = NodeProps<ContactFlowNode>;

export const CreateableContactFlowNodes: {
  type: Exclude<ContactFlowActionType, 'entry'>;
  title: string;
  component: ComponentType<ContactFlowNodeProps>;
}[] = [
  { type: ContactFlowActionType.Answer, title: 'Answer', component: AnswerNode },
  { type: ContactFlowActionType.CheckExclusion, title: 'Check Exclusion', component: CheckExclusionNode },
  { type: ContactFlowActionType.Delay, title: 'Delay', component: DelayNode },
  { type: ContactFlowActionType.Enqueue, title: 'Enqueue', component: EnqueueNode },
  { type: ContactFlowActionType.FetchLead, title: 'Fetch Lead', component: FetchLeadNode },
  { type: ContactFlowActionType.HangUp, title: 'Hang Up', component: HangUpNode },
  { type: ContactFlowActionType.LexBotAudio, title: 'Lex Bot Audio', component: LexBotAudioNode },
  { type: ContactFlowActionType.NoOp, title: 'No Op', component: NoOpNode },
  { type: ContactFlowActionType.PlayMessage, title: 'Play Message', component: PlayMessageNode },
  { type: ContactFlowActionType.SetAttribute, title: 'Set Attribute', component: SetAttributeNode },
  { type: ContactFlowActionType.SetDisposition, title: 'Set Disposition', component: SetDispositionNode },
  { type: ContactFlowActionType.WaitDTMF, title: 'Wait DTMF', component: WaitDTMFNode },
  { type: ContactFlowActionType.TransferExternal, title: 'Transfer External', component: TransferExternalNode },
  { type: ContactFlowActionType.UnsetAttribute, title: 'Unset Attribute', component: UnsetAttributeNode },
];

export const ContactFlowNodes: NodeTypes = CreateableContactFlowNodes.reduce(
  (p, { type, component }) => ({
    ...p,
    [type]: component,
  }),
  { [ContactFlowActionType.Entry]: EntryNode, default: DefaultNode },
);
